import { useSearchParams } from 'react-router-dom'
import { ColorCustom } from 'vnetwork-ui/dist/types'

interface useTabsProps {
    className?: string
    tabs: {
        label: string
        value: string
        startIcon?: JSX.Element
        component: JSX.Element
        endIcon?: JSX.Element
        hidden?: boolean
    }[]
    clearFilters?: boolean
}

const useTabs = ({
    tabs,
    clearFilters = false,
    className = '',
}: useTabsProps) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const activeTab = searchParams?.get('tab') || tabs?.[0]?.value

    const setActiveTab = (newTab: string) => {
        setSearchParams((prev) => {
            prev.set('tab', newTab)
            if (clearFilters) prev.delete('filters')
            return prev
        })
    }

    const TabComponent = tabs
        ?.filter((tab) => !tab.hidden)
        ?.find((tab) => tab.value === activeTab)?.component

    const TabProps = {
        tabs: tabs
            ?.filter((tab) => !tab.hidden)
            ?.map((item) => ({
                ...item,
                label: item.label,
            })),
        activeTab: activeTab,
        onChangeTab: setActiveTab,
        color: 'info' as ColorCustom,
        tabClassName: `uppercase text-gray-500 [&.text-info]:!text-primary ${className}`,
    }

    return {
        TabProps,
        TabComponent,
        activeTab,
        setActiveTab,
    }
}

export default useTabs
